import { schema as ContactSchema } from '__core/shared/model/contact/Contact.schema';
import { schema as TicketSchema } from '__core/shared/model/ticket/Ticket.schema';
import { loanworksSchema as ObjectiveSchema } from '__core/shared/model/finance/Objective.schema';
import { schema as SecuritySchema } from '__core/shared/model/finance/Security.schema';
import { schema as AssetFinanceDetailSchema } from '__core/shared/model/finance/AssetFinanceDetail.schema';
import Lodgement from '__core/shared/model/lodgement/Lodgement';
import LodgementBackChannelHistory from '__core/shared/model/lodgement/LodgementBackChannelHistory';
import LodgementLodgeHistory from '__core/shared/model/lodgement/LodgementLodgeHistory';
import lodgement from './lodgement.component';
import sendDocuments from './sendDocuments.component';
import stMacquarieAssetFinanceSendDocuments from './macquarieAssetFinanceSendDocuments.component';
import stNmbButton from './nmbButton.component';
import lodgementResponseErrors from './lodgementResponseErrors.component';

export default angular
  .module('st.Lodgement', ['st.Core', 'angular-cache'])
  .factory('Lodgement', () => Lodgement)
  .factory('LodgementBackChannelHistory', () => LodgementBackChannelHistory)
  .factory('LodgementLodgeHistory', () => LodgementLodgeHistory)
  .component('sendDocuments', sendDocuments)
  .component('stMacquarieAssetFinanceSendDocuments', stMacquarieAssetFinanceSendDocuments)
  .component('stNmbButton', stNmbButton)
  .component('lodgementResponseErrors', lodgementResponseErrors)
  .component('lodgement', lodgement)
  .service('lodgementService', ($rootScope, $http, dataService, INSTANCE, LODGEMENT) => ({
    isAnyLodgementEnabled: () =>
      $rootScope.hasApplyOnlineEnabled() ||
      $rootScope.hasSimpologyEnabled() ||
      $rootScope.hasDriveOnlineEnabled() ||
      $rootScope.hasLoanWorksEnabled(),

    sendApplication: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LODGEMENT.API.SEND_APPLICATION,
        { params },
        null,
        true
      ),
    sendApplicationNmb: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LODGEMENT.API.APPLY_ONLINE_SEND_APPLICATION_NMB,
        { params },
        null,
        true
      ),
    applyOnlineSilentLogin: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LODGEMENT.API.APPLY_ONLINE_SILENT_LOGIN,
        params,
        null,
        true
      ),
    sendDocuments: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LODGEMENT.API.SEND_DOCUMENTS,
        { params },
        null,
        true
      ),
    macquarieAssetFinanceSendDocuments: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LODGEMENT.API.MACQUARIE_ASSET_FINANCE_SEND_DOCUMENTS,
        { params },
        null,
        true
      ),
    isSimpologyTestBank: (gateway) =>
      !gateway.some((g) => g.type === 'SIMPOLOGY' && g.name === 'GUIDEBOOK_PROD') &&
      gateway.some((g) => g.type === 'SIMPOLOGY' && g.name === 'GUIDEBOOK_DEV')
  }))
  .service(
    'lodgementValidationService',
    ($rootScope, helperService, Address, PersonalTitle) => {
      const validationMessages = {
        hasAccreditation: 'Deal Owner does not have Accreditation set for current Lender.',
        hasOrganizationAbn:
          'Organization does not have ABN set, or is not in correct (11 digits) format. Note that Signing-out and Signing-in is required, in order to apply the changes.',
        hasOrganizationAddress:
          'Organization does not have Address set. Note that Signing-out and Signing-in is required, in order to apply the changes.',
        hasOrganizationPhone:
          'Organization does not have Office Phone and its Prefix set. Note that Signing-out and Signing-in is required, in order to apply the changes.',
        hasDealOwnerTitle:
          'Deal Owner does not have its Title set (eg. Mr, Ms, Mrs, Miss or Dr). Note that Signing-out and Signing-in is required, in order to apply the changes.',
        hasAbsLendingPurposeCode:
          '"Review loan products - ABS lending purpose code" is required.'
      };

      return {
        collect(validations = [], data = {}) {
          const lodgementValidationService = this;
          return validations
            .map((key) => lodgementValidationService[key](data))
            .filter(Boolean);
        },
        hasAccreditation({ accreditation }) {
          return accreditation?.brokerIdPrimary ? '' : validationMessages['hasAccreditation'];
        },
        hasAbsLendingPurposeCode({ reviewProducts }) {
          const preferredProduct = reviewProducts
            ?.find(({ isPreferred }) => isPreferred)
            ?.productSplits?.every(
              (split) => split.absLendingPurposeCode?.id && split.absLendingPurposeCode?.value
            );

          return preferredProduct ? '' : validationMessages['hasAbsLendingPurposeCode'];
        },
        hasOrganizationAbn() {
          const { abn } = $rootScope.CurrentOrganization.organization;
          const isNz = helperService.getOrganizationCountry().cca2 === 'NZ';

          if (!helperService.isValidAbn(abn) && !isNz) {
            return validationMessages['hasOrganizationAbn'];
          }

          return '';
        },
        hasOrganizationAddress() {
          return !Address.hasAddress($rootScope.CurrentOrganization.organization.address)
            ? validationMessages['hasOrganizationAddress']
            : '';
        },
        hasOrganizationPhone() {
          return !$rootScope.CurrentOrganization.organization.phoneCode ||
            !$rootScope.CurrentOrganization.organization.phone
            ? validationMessages['hasOrganizationPhone']
            : '';
        },
        hasDealOwnerTitle({ currentTicketOwner }) {
          return currentTicketOwner?.user?.title?.name === PersonalTitle.none.name
            ? validationMessages['hasDealOwnerTitle']
            : '';
        },

        homeLoanGeneric(data) {
          const joiConfig = {
            abortEarly: false,
            allowUnknown: false,
            stripUnknown: true,
            ...(data.context && { context: data.context })
          };

          let validationErrors = [];
          let validationErrorMessages = [];
          validationErrorMessages = validationErrorMessages.concat(
            this.collect(['hasAccreditation', 'hasAbsLendingPurposeCode'], data)
          );

          const assertSchema = (dataPath, joiSchema) => {
            try {
              joi.assert(_.get(data, path) || null, joiSchema, joiConfig);
            } catch (err) {
              if (err && err.isJoi) {
                validationErrors = validationErrors.concat(err.details);
                validationErrorMessages = validationErrorMessages.concat(
                  _.map(err.details, (d) => d.message)
                );
              }
            }
          };

          const driverLicencePaths = [
            'person.information.driverslicensenumber',
            'person.information.driverslicensenameondocument',
            'person.information.driverslicensetype',
            'person.information.driverslicensetype.name',
            'person.information.driverslicensestateofissue',
            'person.information.driverslicenseexpirydate'
          ];
          const passportPaths = [
            'person.information.passportnumber',
            'person.information.passportnameondocument',
            'person.information.passportissuecountry',
            'person.information.passportissuedate',
            'person.information.passportexpirydate'
          ];
          _.forEach(data.contacts, (c) => {
            try {
              joi.assert(c, ContactSchema(joi, c.getName()), joiConfig);
            } catch (err) {
              if (err && err.isJoi) {
                let hasDriverLicenceError = false;
                let hasPassportError = false;
                const len = err.details?.length || 0;
                for (let i = 0; i < len; i += 1) {
                  err.details[i].idContact = c.id;
                  if (
                    !hasDriverLicenceError &&
                    driverLicencePaths.indexOf(err.details[i]?.path?.join('.')?.toLowerCase()) >
                      -1
                  ) {
                    hasDriverLicenceError = true;
                  }
                  if (
                    !hasPassportError &&
                    passportPaths.indexOf(err.details[i]?.path?.join('.')?.toLowerCase()) > -1
                  ) {
                    hasPassportError = true;
                  }
                }

                if (!hasDriverLicenceError && hasPassportError) {
                  const eLen = err.details?.length || 0;
                  for (let e = 0; e < eLen; e += 1) {
                    const idx = _.findIndex(
                      err.details,
                      (d) => passportPaths.indexOf(d?.path?.join('.')?.toLowerCase()) > -1
                    );
                    if (idx > -1) {
                      err.details.splice(idx, 1);
                    }
                  }
                }
                if (hasDriverLicenceError && !hasPassportError) {
                  const eLen = err.details?.length || 0;
                  for (let e = 0; e < eLen; e += 1) {
                    const idx = _.findIndex(
                      err.details,
                      (d) => driverLicencePaths.indexOf(d?.path?.join('.')?.toLowerCase()) > -1
                    );
                    if (idx > -1) {
                      err.details.splice(idx, 1);
                    }
                  }
                }
                validationErrors = validationErrors.concat(err.details);
                validationErrorMessages = validationErrorMessages.concat(
                  _.map(err.details, (d) => d.message)
                );
              }
            }
          });

          assertSchema('ticket', TicketSchema(joi));
          assertSchema('ticket.objectives', ObjectiveSchema(joi));
          assertSchema(
            'securitySplits',
            joi.array().items(SecuritySchema(joi, 'Security details -')).min(1).required()
          );

          return {
            validationErrors,
            validationErrorMessages: _.uniq(validationErrorMessages)
          };
        },

        assetFinanceGeneric(data) {
          const joiConfig = {
            abortEarly: false,
            allowUnknown: false,
            stripUnknown: true,
            context: {
              isAssetFinance: true,
              clientID: 1
            }
          };

          let validationErrors = [];
          let validationErrorMessages = [];
          validationErrorMessages = validationErrorMessages.concat(
            this.collect(['hasAccreditation'], data)
          );

          _.forEach(data.contacts, (c) => {
            try {
              joi.assert(c, ContactSchema(joi, c.getName()), joiConfig);
            } catch (err) {
              if (err && err.isJoi) {
                const len = err.details?.length || 0;
                for (let i = 0; i < len; i += 1) {
                  err.details[i].idContact = c.id;
                }
                validationErrors = validationErrors.concat(err.details);
                validationErrorMessages = validationErrorMessages.concat(
                  _.map(err.details, (d) => d.message)
                );
              }
            }
          });

          try {
            joi.assert(
              data?.ticket || null,
              TicketSchema(joi).keys({ objectives: joi.any() }),
              joiConfig
            );
          } catch (err) {
            if (err && err.isJoi) {
              validationErrors = validationErrors.concat(err.details);
              validationErrorMessages = validationErrorMessages.concat(
                _.map(err.details, (d) => d.message)
              );
            }
          }

          try {
            joi.assert(
              data?.loan?.assetDetails || [],
              joi
                .array()
                .items(AssetFinanceDetailSchema(joi, 'Asset to be financed - '))
                .label('Asset to be financed'),
              joiConfig
            );
          } catch (err) {
            if (err && err.isJoi) {
              validationErrors = validationErrors.concat(err.details);
              validationErrorMessages = validationErrorMessages.concat(
                _.map(err.details, (d) => d.message)
              );
            }
          }

          return {
            validationErrorMessages: _.uniq(validationErrorMessages),
            validationErrors
          };
        }
      };
    }
  )
  .service(
    'lodgementsService',
    (
      $q,
      $http,
      $rootScope,
      logger,
      LODGEMENT,
      Lodgement,
      lodgementService,
      lodgementValidationService,
      dataService,
      CacheFactory
    ) => {
      let cache;
      if (!CacheFactory.get(LODGEMENT.CACHE.NAME)) {
        cache = CacheFactory(LODGEMENT.CACHE.NAME, LODGEMENT.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || LODGEMENT.CACHE.NAME,
          params
        });

      return {
        clearCache: () => cache.removeAll(),
        getAvailable(params) {
          return dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            Lodgement.build,
            $http.get,
            LODGEMENT.API.GET_AVAILABLE,
            { params }
          );
        },
        async loadApplication(idTicket) {
          const available = await this.getAvailable({
            idTicket: idTicket,
            isActive: true,
            fields: LODGEMENT.FIELDS.APPLICATION,
            ignoreCache: true
          });

          const sorted = _.chain(available)
            .filter((application) => application.isActive)
            .sortBy('timeStamp')
            .reverse()
            .value();

          return sorted && sorted[0];
        },

        gateways: {
          applyonline: {
            id: 1,
            value: 'Apply Online',
            workflowType: ['home_loan', 'asset_finance'],
            type: 'applyonline',
            isActive: true,
            isLenderSupported: ({ id, gateway, uuid }) => {
              if ($rootScope.isAstuteOrg()) {
                return (
                  LODGEMENT.APPLY_ONLINE_SUPPORTED_LENDERS_ASTUTE.includes(uuid) ||
                  LODGEMENT.APPLY_ONLINE_SUPPORTED_LENDERS_ASTUTE.includes(id)
                );
              }

              if ($rootScope.isSfg()) {
                if (id === '42a574159c95d014b3c7c7dd1da8d9ee') {
                  // ANZ AF
                  return false;
                }
              }

              return (
                gateway.some(
                  (g) =>
                    (g.type === 'APPLY_ONLINE' || g.type === 'NEXT_GEN') &&
                    g.name === 'DOC_CLASS'
                ) && $rootScope.hasApplyOnlineEnabled()
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) => {
              return lodgementValidationService.collect([], data);
            },
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id && gatewayCredential.brokerUsername
              );
            }
          },
          simpology: {
            id: 2,
            value: 'LOANAPP',
            workflowType: ['home_loan'],
            type: 'simpology',
            isActive: true,
            isLenderSupported: ({ gateway }) => {
              return (
                gateway.some(
                  (g) =>
                    g.type === 'SIMPOLOGY' &&
                    (g.name === 'DOC_CLASS' ||
                      g.name === 'GUIDEBOOK_PROD' ||
                      g.name === 'GUIDEBOOK_DEV')
                ) && $rootScope.hasSimpologyEnabled()
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) => {
              return {
                validationErrorMessages: lodgementValidationService.collect(
                  [
                    'hasAccreditation',
                    'hasOrganizationAbn',
                    'hasOrganizationAddress',
                    'hasOrganizationPhone',
                    'hasDealOwnerTitle'
                  ],
                  data
                )
              };
            },
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          elodge: {
            id: 3,
            value: 'E Lodge',
            workflowType: ['home_loan'],
            type: 'elodge',
            isActive: false
          },
          driveonline: {
            id: 4,
            value: 'Drive Online',
            workflowType: ['asset_finance'],
            type: 'driveonline',
            isActive: true,
            isLenderSupported: ({ gateway }) => {
              return (
                gateway.some((g) => g.type === 'DRIVE_ONLINE' && g.name === 'DOC_CLASS') &&
                $rootScope.hasDriveOnlineEnabled()
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) => {
              return {
                validationErrorMessages: lodgementValidationService.collect(
                  ['hasAccreditation'],
                  data
                )
              };
            },
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id &&
                  gatewayCredential.brokerUsername &&
                  gatewayCredential.brokerPassword
              );
            }
          },
          pepperassetfinance: {
            id: 5,
            value: 'Pepper Asset Finance',
            workflowType: ['asset_finance'],
            type: 'pepperassetfinance',
            loginUrl: $rootScope.isLearnOrganization()
              ? 'https://appflow-uat.pepper.com.au/suite/?signin=native'
              : 'https://appflow.pepper.com.au/suite/?signin=native',
            isActive: true,
            isLenderSupported: ({ id }) => {
              return (
                id === '3a7c90d56743bde1d95fbae2f2c700af' &&
                $rootScope.hasPepperAssetFinanceEnabled()
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id && gatewayCredential.brokerUsername
              );
            }
          },
          plentiAssetFinance: {
            id: 6,
            value: 'Plenti Asset Finance',
            workflowType: ['asset_finance'],
            loginUrl: $rootScope.isDev()
              ? 'https://portal.test.plenti.cloud/authentication'
              : 'https://portal.plenti.com.au/authentication',
            type: 'plenti',
            isActive: true,
            isLenderSupported: ({ id }) => {
              return id === '1b2cea2b3147d13e368e14bbd5ca25ea';
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          macquarieassetfinance: {
            id: 7,
            value: 'Macquarie Asset Finance',
            workflowType: ['asset_finance'],
            loginUrl: $rootScope.isLearnOrganization()
              ? `https://demo.macquarie.com.au/maclease/macleasestart.do`
              : 'https://introducer.macquarie.com.au/',
            type: 'macquarieassetfinance',
            isActive: true,
            isLenderSupported: ({ id }, productType) => {
              const macquarieAssetFinanceLenders = [
                'afee27132d1ff1ae3a56aa4518b99ed6', // Macquarie Leasing
                '706c64a6b29d4f9ccbf770c62181824f', // Macquarie Equipment Rentals
                'c3fb8eff8660d8d037d050e308051e4e' // Macquarie Premium Funding
              ];

              const isNovatedLease = productType === 3;

              return (
                macquarieAssetFinanceLenders.includes(id) &&
                $rootScope.hasMacquarieAssetFinanceEnabled() &&
                !isNovatedLease
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          latitude: {
            id: 8,
            value: 'Latitude',
            workflowType: ['asset_finance'],
            type: 'latitude',
            isActive: false,
            loginUrl: 'https://emotor.latitudefinancial.com.au/',
            isLenderSupported: ({ id }) => {
              return (
                id === '8e1e4743ad62790dceedfe98b7290455bea68d2466141c7f14c1179930b6a805' &&
                $rootScope.hasLatitudeEnabled()
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id && gatewayCredential.brokerUsername
              );
            }
          },
          loanworks: {
            id: 9,
            value: 'Loanworks',
            workflowType: ['home_loan'],
            type: 'loanworks',
            isActive: true,
            isLenderSupported: ({ id }) => {
              return $rootScope.isDev()
                ? false
                : id === '48e3d546cc6279dadae4ab3dace3ecd661cff2e1e6c2d79eddea12ff017503a6' ||
                    id === 'a422e5e5a235a545d128c0f698e9cebe40b78cc484bf254046cd3421262e9de9';
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              _.merge(
                lodgementValidationService.homeLoanGeneric({
                  ...data,
                  context: { auAddressOnly: true }
                }),
                {
                  validationErrorMessages: lodgementValidationService.collect(
                    ['hasOrganizationAbn'],
                    data
                  )
                }
              ),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          metro: {
            id: 10,
            value: 'Metro',
            workflowType: ['asset_finance'],
            type: 'metro',
            loginUrl: $rootScope.isDev()
              ? 'https://webconnectstg.metrofin.com.au/'
              : 'https://broker.metrofin.com.au/',
            isActive: true,
            isLenderSupported: ({ id }) => {
              return id === 'f832d8a687e2f6f5f96453a26d111989';
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id &&
                  gatewayCredential.brokerUsername &&
                  gatewayCredential.brokerPassword
              );
            }
          },
          macquarieassetfinanceNovatedLease: {
            id: 11,
            value: 'Macquarie Asset Finance Novated Lease',
            workflowType: ['asset_finance'],
            loginUrl: $rootScope.isLearnOrganization()
              ? `https://demo.macquarie.com.au/maclease/macleasestart.do`
              : 'https://introducer.macquarie.com.au/',
            type: 'macquarieassetfinanceNovatedLease',
            isActive: $rootScope.isDev() || false,
            isLenderSupported: ({ id }, productType) => {
              const macquarieAssetFinanceLenders = [
                'afee27132d1ff1ae3a56aa4518b99ed6' // Macquarie Leasing
              ];

              const isNovatedLease = productType === 3;

              return (
                macquarieAssetFinanceLenders.includes(id) &&
                $rootScope.hasMacquarieAssetFinanceEnabled() &&
                isNovatedLease
              );
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner.gatewayAccreditations,
                (gatewayCredential) =>
                  gatewayCredential.idGateway === self.id && gatewayCredential.brokerUsername
              );
            }
          },
          getCapital: {
            id: 12,
            value: 'Shift',
            workflowType: ['asset_finance'],
            type: 'getCapital',
            loginUrl: '',
            isActive: true,
            isLenderSupported: ({ id }) => {
              return id === 'de7c99f101e2b30869bbbf66eb50c6a6';
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner?.gatewayAccreditations || [],
                (gatewayCredential) =>
                  gatewayCredential?.idGateway === self?.id && gatewayCredential?.brokerUsername
              );
            }
          },
          westpacNZ: {
            id: 13,
            value: 'Westpac New Zealand',
            workflowType: ['home_loan'],
            type: 'westpacNZ',
            loginUrl: '',
            isActive: $rootScope.isDev() || false,
            isLenderSupported: ({ id }) => {
              return id === '460c97355b421b53d39c06cc35dd36f5' && $rootScope.isDev();
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) => {},
            hasOwnerGatewayAccreditation({ currentTicketOwner }) {
              const self = this;
              return _.some(
                currentTicketOwner?.gatewayAccreditations || [],
                (gatewayCredential) =>
                  gatewayCredential?.idGateway === self?.id && gatewayCredential?.brokerUsername
              );
            }
          },
          plentiPersonalLoan: {
            id: 14,
            value: 'Plenti Personal Loan',
            workflowType: ['asset_finance'],
            loginUrl: '',
            type: 'plenti',
            isActive: true,
            isLenderSupported: ({ id }, productType, preferredProduct) => {
              const isUnsecured =
                preferredProduct?.selectedProduct?.assetType?.length === 1 &&
                indexOf(preferredProduct?.selectedProduct?.assetType, 'UNSECURED') > -1;
              return id === '1b2cea2b3147d13e368e14bbd5ca25ea' && isUnsecured;
            },
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          societyOne: {
            id: 15,
            value: 'SocietyOne',
            workflowType: ['asset_finance'],
            loginUrl: `https://${
              $rootScope.isDev() ? 'uat-' : ''
            }broker.societyone.com.au/login`,
            type: 'societyOne',
            isActive: true,
            isLenderSupported: ({ id }) =>
              id === '58ec614ca97827e31f6156fff802c499f4a71d7ff5ad843a56ae9691b48cac0c',
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          libertyAssetFinance: {
            id: 16,
            value: 'Liberty',
            workflowType: ['asset_finance'],
            loginUrl: 'https://iq.liberty.com.au/#/login',
            type: 'liberty',
            isActive: true,
            isLenderSupported: ({ id }) => id === 'ecd9183e2ae5c7040db615a973fcf845',
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          },
          moneyPlace: {
            id: 17,
            value: 'MoneyPlace',
            workflowType: ['asset_finance'],
            loginUrl: 'https://qa.moneyplace.com.au/start/',
            type: 'moneyPlace',
            isActive: true,
            isLenderSupported: ({ id }) =>
              id === '88fa70c1ffe803e86abda8b0058a202ce8313c05367249c5dab33639205572a7' ||
              id === '9f994633e50733be3a3b46afa3d52b52d000536f836baf66eafd05c2bce08a99',
            sendApplication(params) {
              params.type = this.type;
              return lodgementService.sendApplication(params);
            },
            isMinimumFieldsFilled: (data) =>
              lodgementValidationService.assetFinanceGeneric(data),
            hasOwnerGatewayAccreditation() {
              return true;
            }
          }
        },

        getGateways() {
          return _.values(this.gateways);
        }
      };
    }
  )
  .constant('LODGEMENT', {
    API: {
      SEND_APPLICATION: '/api/v1/lodgements/send-application/',
      GET_AVAILABLE: '/api/v1/lodgements/available/',
      APPLY_ONLINE_SEND_APPLICATION_NMB: '/api/v1/lodgement/apply-online/send-application-nmb/',
      APPLY_ONLINE_SILENT_LOGIN: '/api/v1/lodgement/apply-online/silent-login/',
      SEND_DOCUMENTS: '/api/v1/lodgements/send-documents/',
      MACQUARIE_ASSET_FINANCE_SEND_DOCUMENTS:
        '/api/v1/integrations/macquarie-asset-finance/send-documents/'
    },
    APPLY_ONLINE_SUPPORTED_LENDERS_ASTUTE: [
      '88792f49-a9d5-4562-97a0-64a9cf4b83cb',
      'ef06b2a6-6055-4220-a703-8a23e1d5aeea',
      'a873bd06-139a-412a-a54e-6ca36f43e27b',
      'f973abd9-373b-4224-8f0f-b6f5a59237bb',
      'b7df6c02-af2e-41a9-bdf1-041eddeed138',
      '035d95e9-cf77-4efc-bc9f-5dc37486f6e0',
      '2bfb75ec-7a16-4abb-bd7b-1adac2cf57f7',
      'e990fc8c-6a4e-4e50-893f-e0aeec8aaeff',
      'b711940a-d88b-40d5-85cc-2fabbba89244',
      'ed53c13d-a1e4-4834-b1dd-4ea64553bd67',
      '5f693f97-e6c2-462c-9cce-ce67ab348987',
      '0c8b40f0-cadf-4a80-94a5-83d85f15458d',
      'be13b223-e111-4f4e-95c3-7789011fecd2',
      'aa528105-0c7f-4c44-9678-fd82ce95aa3e',
      '705f6e74-20c5-428e-bae5-262c3ff6ed41',
      '1696f273-34ee-4e0f-a505-2c1dc69db835',
      '0ddf2997-a052-4335-8ac0-591ff0739e05',
      'ab23a69f-add3-4955-819a-9578d56f5128',
      '0578ce00-6921-43e6-aad7-f401f05e0284',
      'bbe26d52-8b7c-4971-bd0a-ac41ba82a0f0',
      '2fa0a347-8679-4ac9-88ab-b695dbc0f413',
      '82d18cee-ebbc-4c64-ab94-2913bbe1eb60',
      'a31c7897-b665-46b9-bb89-c0bdf3ea97fd',
      'dd22c86a-c1f7-4cc9-8c44-99857ed4098f',
      '88698329-440a-4cb4-9e9d-fd59b75470c5',
      'a34e1d15-d98e-4e33-a8a9-d22755eae2f2',
      '5f675200-d535-4568-a386-884164cfa3d8',
      'c4c05f21-eccc-41db-af8f-fc5ef64a7e6c',
      '191affdb-0656-45ea-bc47-b31a7f1c32a0',
      '80aa2f23-54f0-4692-b6dd-55c9e6d2ab9d',
      '114f67a6-cfb9-4ae9-8208-7b02289f95c7',
      '52bd957d-0258-4c59-b113-2ac57e94c8a5',
      '47a1baaf-acae-43e7-b2ff-caecddd7a6b1',
      'cc4a6d15-a13e-43c3-bd18-57068aeab5e4',
      '0ffe5c22-4b7c-4682-8c24-a277b42c1e2b',
      '01c45fa6-d840-41d5-8fdb-12b8361de561',
      '48de9816-d762-4f16-afa3-a6f570db9561',
      '15efb23e-3e06-4f26-9cc9-56fd1f3aa44a',
      '931743d4-f845-4c19-9179-2bb8fa6e6a2d',
      'd92363fa-0c76-448f-8252-29268cf99c62',
      '7e1c0ee2-db36-412d-9f81-42b6efda1631',
      '1e09ce6d-1236-476d-a420-157b6ef9c7df',
      '1c08560f-eeb2-462b-8c93-ee219ead7eba',
      '42a574159c95d014b3c7c7dd1da8d9ee',
      '6aa5caa86070729747d170d3d22f91fa',
      '1324599db9f2e9cfa3fda48345ceea43',
      '8952baca0dc9ca38f38db0a01a3e2702',
      'a8de51bc04d85561c0c17d25a6d1317e',
      '36bf4dfeb46010b3589244235aa43c37',
      '5d71a94803eacbbf6db6b573a05b895d',
      'cbf85961f9a503a225a01280015569a17ea16d890877da06f8628c267dff8194',
      'ef06f4da38cdac166b7fc455e5db2a25',
      '08c0a6777b519c6cbdb73a8bc360d18f',
      '5ae5b1fb1206b513b94b014cf0cd0019',
      'ec85abaf0179c3b77274ee31355fc139',
      '368a5b37934aaa4e0582aa8226c1194ff3139c1d2b10a7631bcf3ea55f35a8e2',
      '217b7f8dc656465299bd338ea25bce2f'
    ],
    DRIVE_ONLINE_SUPPORTED_LENDERS: [
      'cdc7fb9102a1fa2aa78aba977171e83c', // WBC
      '26e55233aa4461a722b9cf30d6818f15', // BOM
      '7803e246cede0a6d6ced6b0bc4811116', // BSA
      'e5fdbfaa24c3a160ea7127003f1e71b2', // STG
      'e80d8fefb8746ac2fb51860eb3467b14' // CAF
    ],
    MACQUARIE_ASSET_FINANCE: {
      PURPOSE_OPTIONS: [
        { id: '', title: 'Select one' },
        { id: 'FOR_APPROVAL', title: 'For approval' },
        { id: 'FOR_SETTLEMENT', title: 'For settlement' }
      ],
      DOCUMENT_CLASS_OPTIONS: [
        { id: '', title: 'Select one' },
        { id: 'CREDIT_CHECK', title: 'Credit check' },
        { id: 'FRAUD_CHECK', title: 'Fraud check' },
        { id: 'IDENTITY_CHECK', title: 'Identity check' },
        { id: 'ID_MATRIX_CHECK', title: 'Id matrix check' },
        { id: 'CUSTOMER_FINANCIALS', title: 'Customer financials' },
        { id: 'IDENTIFICATION', title: 'Identification' },
        { id: 'INVOICES_BANK_DETAILS', title: 'Invoices bank details' },
        { id: 'LETTERS', title: 'Letters' },
        { id: 'PAYSLIP', title: 'Payslip' },
        { id: 'PRIVACY_CONSENT', title: 'Privacy consent' },
        { id: 'PRIVATE_SALE', title: 'Private sale' },
        { id: 'OTHER', title: 'Other' },
        { id: 'ADHOC', title: 'Adhoc' },
        { id: 'AMEX_AUTHORITY_FORM', title: 'Amex authority form' },
        { id: 'ASSET_TAX_INVOICE', title: 'Asset tax invoice' },
        { id: 'BANK_DEPOSIT_SLIP', title: 'Bank deposit slip' },
        { id: 'BUSINESS_DECLARATION', title: 'Business declaration' },
        { id: 'CHATTEL_MORTGAGE_PARTICULARS', title: 'Chattel mortgage particulars' },
        { id: 'CONTRACT_SCHEDULE', title: 'Contract schedule' },
        { id: 'COVER_LETTER_AND_AGREEMENT', title: 'Cover letter and agreement' },
        { id: 'AMEX_PAYOUT_FORM', title: 'Amex payout form' }
      ]
    },
    SOCIETY_ONE: {
      LOAN_PURPOSES: [
        { id: '', value: 'Select one' },
        { id: 'Pay off credit cards or loans', value: 'Pay off credit cards or loans' },
        { id: 'Vehicle purchase', value: 'Vehicle purchase' },
        { id: 'Home improvement', value: 'Home improvement' },
        { id: 'Holiday', value: 'Holiday' },
        { id: 'Wedding', value: 'Wedding' },
        { id: 'Education expenses', value: 'Education expenses' },
        { id: 'Business purpose', value: 'Business purpose' },
        { id: 'Property acquisition costs', value: 'Property acquisition costs' },
        { id: 'Medical expenses', value: 'Medical expenses' },
        { id: 'Other purposes', value: 'Other purposes' }
      ]
    },
    FIELDS: {
      APPLICATION: {
        list: [
          'id',
          'applicationId',
          'lenderAssignedId',
          'idLender',
          'idOrganization',
          'idTicket',
          'isActive',
          'isSubmitted',
          'status',
          'type',
          'timeStamp'
        ]
      }
    },
    CACHE: {
      NAME: 'lodgementsCache',
      STORE: {
        TTL: 5 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  });
